import React from 'react';
import { PhotoUpload } from '../components/PhotoUpload';
import { AdUnit } from '../components/AdUnit';

const AD_SLOT_UPLOAD = '5253813406'; // Display – auto format (same as home)

export function UploadPage() {
  return (
    <div>
      <h1>Add Your Photo</h1>
      <p style={{ textAlign: 'center', color: '#666', marginBottom: '8px' }}>
        Submit your photo to be included in the reparations vote
      </p>

      <AdUnit slot={AD_SLOT_UPLOAD} />

      <PhotoUpload />
    </div>
  );
}
